import { nextTick } from "vue";
/**
 * Scrolls a container back to the top after a reactive change that swaps its
 * content (a wizard step, a paginated list, a tab, ...) — call from the
 * watcher/handler right after the state mutation that triggers the swap.
 * Queued on the next tick so it runs once the DOM has already re-rendered
 * with the new content, otherwise the container's scrollHeight still
 * reflects the previous content.
 */
export function useScrollReset() {
    function scrollContainerToTop(selector) {
        void nextTick(() => {
            document.querySelector(selector)?.scrollTo({ top: 0 });
        });
    }
    return { scrollContainerToTop };
}
